// src/hooks/angularHook.js
import { initCarouselScroll } from ".src/core/carouselScroll.js";

/**
 * Helper para Angular: habilita el scroll horizontal con arrastre (mouse/touch)
 * en un elemento del DOM.
 *
 * @param {HTMLElement} element - Referencia al elemento del carrusel (obtenido con @ViewChild o ElementRef)
 *
 * @example
 * @ViewChild('carousel') carouselRef: ElementRef;
 *
 * ngAfterViewInit() {
 *   useAngularCarouselScroll(this.carouselRef.nativeElement);
 * }
 */
export function useAngularCarouselScroll(element) {
  if (element) {
    initCarouselScroll(element);
  } else {
    console.warn("useAngularCarouselScroll: elemento no válido");
  }
}